module.exports = __webpack_public_path__ + "static/group-30d7fde2f8e8e1d9d0da82b19fb61870.mp4";